
import React, { memo, useCallback, useMemo, useState } from 'react'
import './DataListComp.css'
import { useEffect } from 'react';
import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { WishListDelData, WishListaddData } from '../../Redux/Slices/Masters/WishListSlice';
import { HoldDelData, HoldaddData } from '../../Redux/Slices/Masters/HoldSlice';
import { ConfirmListDelData, ConfirmListaddData } from '../../Redux/Slices/Masters/ConfirmSlice';
import { ViewRequestDelData, ViewRequestaddData } from '../../Redux/Slices/Masters/ViewRequestSlice';
import { Dropdown } from 'primereact/dropdown';
import GlidGrid from '../../Components/Grid/GlidGrid';
import { AlertPopup, ConfirmPopupBig, GridActionButton } from '../../Asset/common';
import Form from 'react-bootstrap/Form'
import generateExcel from '../../Components/Grid/ExcelGenerator';
import { fetchDataNew as DynamicFetchNew, addData } from '../../Redux/Slices/Transaction/DynamicSlice';
import PacketSearchComp from '../Transaction/PacketSearchComp'
import { useNavigate } from 'react-router-dom';
import PktErrorComp from '../../Components/PktErrorComp';
import { IoGrid } from 'react-icons/io5';
import { FaLink, FaRectangleList } from 'react-icons/fa6';
import { FlagIcon } from 'react-flag-kit';
import InfiniteScroll from 'react-infinite-scroll-component';
import { RiCloseCircleFill, RiFilterFill, RiWhatsappFill } from 'react-icons/ri';
import { IoMdDownload, IoMdRefresh, IoMdRefreshCircle } from 'react-icons/io';
import { Modal } from 'react-bootstrap';
import '../../Pages/Mix/Transaction/MixMaster.css'
import useAutoAdjustHeight from '../../Components/useAutoAdjustHeight/useAutoAdjustHeight';
import { fetchWebStockPartyData } from '../../Redux/Slices/Masters/PacketSearchSlice';
import { HiChartSquareBar } from "react-icons/hi";
import VerticalChart from '../../Components/Chart/VerticalChart';
import { FaObjectUngroup } from "react-icons/fa6";

function DataListComp(props) {

    let Setting = useSelector(state => state.Setting.Setting);
    let APISetting = useSelector(state => state.APISetting);
    let MemberName = Setting?.find(Setting => Setting.SKEY == 'WebWhatsApp1' && Setting.KEYDESC)?.KEYDESC;
    let MobileNo = Setting?.find(Setting => Setting.SKEY == 'WebWhatsApp1' && Setting.KEYDESC)?.SVALUE;
    let MainPassword = Setting?.find(Setting => Setting.SKEY == 'PKTSEARCHPASS')?.SVALUE;
    let ExcelViewpara = Setting?.find(Setting => Setting.SKEY == 'PktSearchExcelViewPara')?.SVALUE;
    const splitValue = MemberName?.split(',');
    const splitNumberValue = MobileNo?.split(',');
    const [isModalOpen, setModalOpen] = useState(false);
    const [isModalOpenDemo, setModalOpenDemo] = useState(false);
    const [isModalVideoLink, setisModalVideoLink] = useState(false);
    const [VideoLinkRow, setVideoLinkRow] = useState([]);
    const [isOfferCountModal, setIsOfferCountModal] = useState(false);
    const [offerCountRowData, setOfferCountRowData] = useState([]);
    const [LocationColConfig, setLocationColConfig] = useState([]);
    const [showLocSearchModal, setShowLocSearchModal] = useState(false);
    const [AccColConfig, setAccColConfig] = useState([]);
    const [ShowAccSearchModal, setShowAccSearchModal] = useState(false);
    const [IsDeletebtnShow, setIsDeletebtnShow] = useState(false);
    const [btnValues, setbtnValues] = useState([]);


    const { btn } = props;
    const [objTotal, setobjTotal] = useState(props.totalobj[0])
    //let objDs = props.DataSrc;
    const PageName = props.PageName;
    const objViewPara = props.ViewPara;

    // const IsShowTotal = props.ShowTotal;
    const StnStatus = props.StnStatus;
    const IsActive = props.IsActive;
    const IsDeActive = props.IsDeActive;

    let [objDs, setobjDs] = useState(JSON.parse(JSON.stringify(props.DataSrc) || '[]'));


    let [TmpobjDs, setTmpobjDs] = useState(JSON.parse(JSON.stringify(props.DataSrc) || '[]'));

    const dataDivRef = useRef(null);

    const dispatch = useDispatch();

    const [ObjSelTotal, setObjSelTotal] = useState({})

    let [Selectedrow, setSelectedrow] = useState([]);
    let [SelectedrowAcc, setSelectedrowAcc] = useState([]);
    const [Party, setParty] = useState(null);
    const [Location, setLocation] = useState(null);
    const [PagingRange, setPagingRange] = useState(null);
    const [OptionLotDet, setOptionLotDet] = useState(null);
    const [showTotal, setShowTotal] = useState(true);
    const [openPacketSearchCom, setopenPacketSearchCom] = useState(false)
    const [GetViewPara, setGetViewPara] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [PktErrData, setPktErrData] = useState([]);
    const [pagebtnNaviName, setpagebtnNaviName] = useState('');
    let [ViewType, setViewType] = useState('GridView');

    const columnConfigRecord = useSelector(state => state.ColumnConfig.visible);
    const DropDown = useSelector(state => state.DropDown);
    const pageName = PageName === 'STONESEARCH' ? 'STONESEARCH' : 'PACKETSEARCH';

    const [ColumConfig, setColumConfig] = useState()
    const ColumnConfig = async () => {
        setColumConfig(columnConfigRecord?.filter(x => x.MenuCode == 'OFFERTRNPKTSEARCH'));
    }

    useEffect(() => {
        ColumnConfig();
    }, [columnConfigRecord])

    useEffect(() => {
        setbtnValues(btn?.split(",").map(v => v.trim()) || []);
    }, [props])


    let CompCode = Setting?.find(Setting => Setting.SKEY === 'COMP_CODE')?.SVALUE;
    let BarSetting = useSelector(state => state.BarSetting.DynDisp)?.filter(item => item.COMP_CODE == CompCode && item.TYP == 'PKTSEARCH');
    let CertBarSetting = useSelector(state => state.BarSetting.DynDisp)?.filter(item => item.COMP_CODE == CompCode && item.TYP == 'UPCOMING');

    let navigate = useNavigate();
    const videoRef = useRef(null);

    let [visibleItems, setVisibleItems] = useState([]);
    const [itemsPerPage] = useState(12);
    const [errorStatus, setErrorStatus] = useState({});
    const [cardViewHeight, setcardViewHeight] = useState(0);

    const handleMouseOver = (e) => {
        if (e.target.readyState >= 3) {
            e.target.play().catch(error => {

            });
        }
    };
    const handleMouseOut = (e) => {
        e.target.pause();
    };

    const [PageRange, setPageRange] = useState([]);
    useEffect(() => {
        const fetchPageRangeData = () => {
            let GetPageRangeDropDown = DropDown.LOOKUPMAST?.filter(x => x.TYP == 'SearchPageRecerd');
            setPageRange(GetPageRangeDropDown);
        }

        fetchPageRangeData();
    }, [DropDown])

    useEffect(() => {
        if (PageRange?.length > 0) {
            setPagingRange(PageRange[0]); // Set the first item as the default
        }
    }, [PageRange]);

    useEffect(() => {
        let filterStnStatus = props.DataSrc;
        if (StnStatus && StnStatus.length > 0) {
            if (IsActive !== undefined && IsActive !== null) {
                filterStnStatus = props.DataSrc?.filter(
                    item => StnStatus.includes(item.STNSTATUS) && item.ISACTIVE === IsActive
                );
            }
            // else if (IsDeActive !== undefined && IsDeActive !== null) {
            //     filterStnStatus = props.DataSrc?.filter(
            //         item => StnStatus.includes(item.STNSTATUS) && item.ISACTIVE === false
            //     );
            // }
            else {
                filterStnStatus = props.DataSrc?.filter(item => StnStatus.includes(item.STNSTATUS));
            }
        } else {
            if (IsActive !== undefined && IsActive !== null) {
                filterStnStatus = props.DataSrc?.filter(item => item.ISACTIVE === IsActive);
            }
            // else if (IsDeActive !== undefined && IsDeActive !== null) {
            //     filterStnStatus = props.DataSrc?.filter(item => item.ISACTIVE === false);
            // }
            else {
                filterStnStatus = props.DataSrc;
            }
        }
        setobjDs(JSON.parse(JSON.stringify(filterStnStatus) || '[]'));
        setTmpobjDs(JSON.parse(JSON.stringify(filterStnStatus) || '[]'));
    }, [StnStatus, props.DataSrc, IsActive]);


    // useEffect(() => {
    //     let filterStnStatus = props.DataSrc;
    //     if (IsActive) {
    //         if (StnStatus && StnStatus.length > 0) {
    //             filterStnStatus = props.DataSrc?.filter(item => item.ISACTIVE == IsActive && StnStatus.includes(item.STNSTATUS));    
    //         }
    //         else{

    //         }

    //     } else {
    //         filterStnStatus = props.DataSrc;
    //     }
    //     setobjDs(JSON.parse(JSON.stringify(filterStnStatus) || '[]'));
    //     setTmpobjDs(JSON.parse(JSON.stringify(filterStnStatus) || '[]'));
    // }, [IsActive, props.DataSrc]);

    useEffect(() => {
        let TtlDS = props.DataSrc;

        let objTotal = {
            I_PCS: 0,
            I_CARAT: 0.00,
            ORATE: 0,
            DISC: 0.00,
            RATE: 0,
            AMT: 0,
            OAMT: 0
        }

        TtlDS?.forEach(row => {
            objTotal['I_PCS'] += row['I_PCS'];
            objTotal['I_CARAT'] += row['I_CARAT'];
            objTotal['AMT'] += row['RATE'] * row['I_CARAT'];
            objTotal['OAMT'] += row['ORATE'] * row['I_CARAT'];
        });

        objTotal['ORATE'] = objTotal['OAMT'] / objTotal['I_CARAT'];
        objTotal['RATE'] = objTotal['AMT'] / objTotal['I_CARAT'];
        objTotal['DISC'] = 100 - ((objTotal['RATE'] / objTotal['ORATE']) * 100);

        setobjTotal(objTotal);
        // setSelectedrow(localStorage.getItem('PktSearchData'));

    }, [])

    useEffect(() => {
        setobjTotal(props.totalobj[0])
    }, [props.totalobj])

    useEffect(() => {
        getAllData();
    }, [props.DataSrc]);

    const GetselectedRowAcc = (selectedRows) => {
        setSelectedrowAcc(selectedRows);
    };

    const GetselectedRow = (selectedRows, lastEditedRow) => {
        if (Selectedrow?.length) {
            selectedRows?.forEach((row) => {
                let filterRecordRowIndex = Selectedrow?.findIndex(x => x.PKTID == row.PKTID)
                if (filterRecordRowIndex != -1) {
                    Selectedrow[filterRecordRowIndex] = row;
                }
                else {
                    setSelectedrow(selectedRows);
                }
            })

        }
        else {
            setSelectedrow(selectedRows);
        }

        // setSelectedrow(selectedRows);
        // let selectedPktIds = selectedRows.map(x => x.PKTID)

        // objDs.forEach((x, i) => {
        //     if (selectedPktIds.includes(x.PKTID)) {
        //         objDs[i].SELECTED = true;
        //     } else {
        //         objDs[i].SELECTED = false;
        //     }
        // })

        selectedRows?.forEach((row) => {
            let filterRecordRowIndex = objDs?.findIndex(x => x.PKTID == row.PKTID)
            if (filterRecordRowIndex != -1) {
                objDs[filterRecordRowIndex] = row;
            }
        })

        setobjDs(objDs)
        const ObjSelTotal = {
            'I_PCS': 0,
            'I_CARAT': 0,
            'AMT': 0,
            'OAMT': 0,
            'ORATE': 0,
            'RATE': 0,
            'DISC': 0,
        };
        objDs?.forEach(row => {
            if (row.SELECTED == true) {
                ObjSelTotal['I_PCS'] += row['I_PCS'];
                ObjSelTotal['I_CARAT'] += row['I_CARAT'];
                ObjSelTotal['AMT'] += row['RATE'] * row['I_CARAT'];
                ObjSelTotal['OAMT'] += row['ORATE'] * row['I_CARAT'];
            }
        });

        ObjSelTotal['ORATE'] = ObjSelTotal['OAMT'] / ObjSelTotal['I_CARAT'];
        ObjSelTotal['RATE'] = ObjSelTotal['AMT'] / ObjSelTotal['I_CARAT'];
        ObjSelTotal['DISC'] = 100 - ((ObjSelTotal['RATE'] / ObjSelTotal['ORATE']) * 100);

        setObjSelTotal(ObjSelTotal);
    }

    const Columnconfigs = () => {
        setGetViewPara(columnConfigRecord?.filter(x => x.MenuCode == 'STONESEARCH'));
        setLocationColConfig(columnConfigRecord?.filter(x => x.MenuCode == 'PKTSEARCHLOCMAST'));
        setAccColConfig(columnConfigRecord?.filter(x => x.MenuCode == 'PKTSEARCHACCMAST'));
        // setAccColConfig(filtered || []);
    }
    // console.log('col', GetViewPara);
    useEffect(() => {
        Columnconfigs();

        fetchModalData();
    }, [])


    const ExcelGen = async (selectedRows, ConfigName, fileName) => {
        // Filter columns based on IsExcelHide


        const filteredColumns = columnConfigRecord?.filter(column => column.MenuCode == ConfigName && column.IsExcelHide === false);
        // Sort columns based on ExcelOrd
        filteredColumns.sort((a, b) => a.ExcelOrd - b.ExcelOrd);
        // Generate Excel file with sorted columns and selected rows
        // selectedRows.push()
        generateExcel(filteredColumns, selectedRows, fileName, Setting, true)
            .catch(err => AlertPopup.errorPopup(err));
    }

    const copyPacketData = () => {
        const selected = objDs?.filter(x => x.SELECTED);

        if (selected.length === 0) {
            AlertPopup("Please select at least one stone!", "warning");
            return;
        }

        let finalText = "";

        selected.forEach(row => {
            finalText += formatPrintData(row);
        });

        navigator.clipboard
            .writeText(finalText)
            .then(() => {
                AlertPopup("Packet data copied!", "success");
            })
            .catch(() => {
                AlertPopup("Copy failed!", "error");
            });
    };

    const formatPrintData = (row) => {
        return `
            PKT ID : ${row.PKTID} ${row.LAB} ${row.CERTNO}
            Available : ${row.STNSTATUS} (${row.COU_NAME}) ${row.TREATMENT}
            ${row.S_NAME.toUpperCase()} ${row.I_CARAT} ${row.C_NAME} ${row.Q_NAME} ${row.CT_NAME} ${row.PO_NAME} ${row.SY_NAME} ${row.FL_NAME}
            Measurement : ${row.MEASUREMENTS} ,  H&A : ${row.HRT_NAME}
            Table : ${row.TABLE_PER} ,  Depth : ${row.TOTDEPTH_PER}
            Crn : ${row.CRWANGLE} - ${row.CRWHEIGHT_PER} ,  Pav : ${row.PAVANGLE} - ${row.PAVDEPTH_PER}
            Video : ${row.VIDEOLINK1}
            Cert PDF : ${row.PDFLINK}
            ---------------------
            `;
    };

    const handleSave = async (btnName, showModal) => {

        setpagebtnNaviName(btnName)

        localStorage.setItem('PktSearchData', JSON.stringify(Selectedrow?.filter(obj => obj.SELECTED == true && obj.PKTID)))
        // let pktidArray = Array.isArray(Selectedrow) && Selectedrow?.map(obj => obj.SELECTED === true && obj.PKTID);
        let pktidArray = Array.isArray(Selectedrow) && Selectedrow?.filter(obj => obj.SELECTED == true && obj.PKTID)?.map(obj => obj.PKTID);

        const isSelected = Array.isArray(Selectedrow) && Selectedrow?.some(item => item.Selected);


        if ((Selectedrow.length == undefined || Selectedrow.length == 0 || pktidArray.length == 0 || pktidArray == '' || pktidArray == undefined) && (btnName != 'Select All' && btnName != 'Filter' && btnName != 'Refresh' && btnName != 'WhatsApp')) {
            AlertPopup.warningPopup("Please Select atleast one Record !!");
            return
        }
        if (((btnName == 'Hold' || btnName == 'Confirm') && (Party?.Code == null || Party?.Code == undefined))) {
            AlertPopup.warningPopup("Please Select Party !!");
            return
        }
        if (userRole?.toLowerCase() != 'web user' && (Party == undefined || Party == null)) {
            if (btnName == 'Wishlist' || btnName == 'Hold' || btnName == 'Confirm' || btnName == 'View Request') {
                AlertPopup.warningPopup("Please Select Party !!");
                return
            }
        }

        const holdOrConfirmExists = Array.isArray(Selectedrow) && Selectedrow?.some(x => (x.IsHold || x.IsConfirm) && x.SELECTED == true);

        if (holdOrConfirmExists && btnName.includes('Remove') == false && btnName != 'Excel' && btnName != 'Selected' && PageName != 'Hold') {
            AlertPopup.warningPopup("This Packet Is Already Hold or Confirm For Other Party !!");
            return;
        }

        let newObj = { 'PKTID': pktidArray, 'AC_Code': Party == null ? 0 : Party?.Code };

        if (btnName == 'Refresh') {

            localStorage.removeItem('PktId');
            localStorage.removeItem('PktSearchData');
            JSON.parse(localStorage.getItem('isRefresh'))
            setObjSelTotal([]);
            if (props.refreshData) {
                props.refreshData()
            }
        }
        if (btnName == 'Location Upd') {
            setShowLocSearchModal(true);
            // const updatedData = pktidArray?.map(item => ({
            //     PKTID: item,
            //     LOC_CODE: Location.Code
            // }));
            // let ObjJsonDet = {
            //     jsonObj1: updatedData,
            //     SPName: "API_LocationUpd"
            // }
            // await dispatch(addData(ObjJsonDet)).then(() => {
            //     if (props.refreshData) {
            //         props.refreshData();
            //     } else {
            //         window.location.reload();
            //     }
            // });
        }
        if (btnName == 'Wishlist') {
            dispatch(WishListaddData(newObj))
        }
        if (btnName == 'Remove Wishlist') {
            dispatch(WishListDelData(newObj))
        }
        if (btnName == 'Hold') {
            dispatch(HoldaddData(newObj))
            if (props.refreshData) {
                props.refreshData()
            }
        }
        if (btnName == 'Remove Hold') {
            if (newObj.AC_Code == null) {
                newObj.AC_Code = 0;
            }

            dispatch(HoldDelData(newObj))
        }
        if (btnName == 'Confirm') {
            dispatch(ConfirmListaddData(newObj))
            if (props.refreshData) {
                props.refreshData()
            }
        }
        if (btnName == 'Remove Confirm') {
            dispatch(ConfirmListDelData(newObj))
        }
        if (btnName == 'View Request') {
            dispatch(ViewRequestaddData(newObj))
        }
        if (btnName == 'Remove View Request') {
            dispatch(ViewRequestDelData(newObj))
        }
        if (btnName == 'Excel') {
            if (btnName == 'Excel' && Party?.Code) {
                let selectedRowPktIds = Selectedrow?.map(x => x.PKTID && x.SELECTED)
                let payLoad = { AC_CODE: Party?.Code }
                if (selectedRowPktIds.length > 0) {
                    // payLoad.PKTID = selectedRowPktIds
                }
                let response = await dispatch(fetchWebStockPartyData(payLoad))
                let columnConfigName = APISetting?.find(x => x.AC_CODE == Party?.Code)?.COLUMNCONFIG;
                ExcelGen(response, columnConfigName, Party.Name);
            } else {
                ExcelGen(Selectedrow, !ExcelViewpara ? 'PACKETSEARCH' : ExcelViewpara, 'Stock');
            }
        }
        if (btnName == 'Show All') {
            objDs = props.DataSrc;
            setobjDs(props.DataSrc);
            const updatedObjDs = objDs?.map((item) => {
                const isSelected = Selectedrow?.some((row) => row.PKTID == item.PKTID && row.SELECTED);
                return {
                    ...item,
                    SELECTED: isSelected,
                };
            });

            setobjDs(updatedObjDs);
            props.setButtonName(PageName === 'STONESEARCH' ? 'Select All,Show All,Selected,Excel,Confirm,Hold'
                : 'Filter,Select All,Selected,Lab Issue,Jangad Issue,Estimate Issue,MixOut Entry,NonCert Issue,Sale Issue,Price/Disc Upd,Data Upd Entry,Excel,Barcode,IsActive,DeleteAll');
        }
        if (btnName == 'Selected') {

            localStorage.removeItem('pktId');
            props.setButtonName(PageName === 'STONESEARCH' ? 'Select All,Show All,Selected,Excel,Confirm,Hold'
                : 'Filter,Refresh,Select All,Selected,Lab Issue,Jangad Issue,Estimate Issue,MixOut Entry,NonCert Issue,Sale Issue,Price/Disc Upd,Data Upd Entry,Excel,Barcode,IsActive,DeleteAll');
            setobjDs([...Selectedrow])
        }
        if (btnName === 'WhatsApp') {
            if (!Selectedrow || Selectedrow.length === 0) {
                AlertPopup.warningPopup("Please select at least one record to export.");
                return;
            }

            // Excel will download automatically
            ExcelGen(Selectedrow, 'PACKETSEARCH', 'WhatsApp');

            // Then open the modal
            setShowAccSearchModal(true);
        }
        if (btnName === 'Data Copy') {
            copyPacketData();
            return;
        }
        if (btnName == 'Select All') {

            // const updatedData = objDs?.map(item => ({
            //     ...item,
            //     SELECTED: !item.SELECTED,
            // }));


            const allSelected = objDs.every(item => item.SELECTED); // Check if all are selected
            const updatedData = objDs?.map(item => ({
                ...item,
                SELECTED: !allSelected, // Toggle all based on current state
            }));



            setobjDs(updatedData);
            setSelectedrow(updatedData);

            const ObjSelTotal = {
                'I_PCS': 0,
                'I_CARAT': 0,
                'AMT': 0,
                'OAMT': 0,
                'ORATE': 0,
                'RATE': 0,
                'DISC': 0,
            };
            updatedData?.forEach(row => {

                if (row.SELECTED == true) {
                    ObjSelTotal['I_PCS'] += row['I_PCS'];
                    ObjSelTotal['I_CARAT'] += row['I_CARAT'];
                    ObjSelTotal['AMT'] += row['RATE'] * row['I_CARAT'];
                    ObjSelTotal['OAMT'] += row['ORATE'] * row['I_CARAT'];
                }
            });

            ObjSelTotal['ORATE'] = ObjSelTotal['OAMT'] / ObjSelTotal['I_CARAT'];
            ObjSelTotal['RATE'] = ObjSelTotal['AMT'] / ObjSelTotal['I_CARAT'];
            ObjSelTotal['DISC'] = 100 - ((ObjSelTotal['RATE'] / ObjSelTotal['ORATE']) * 100);

            setObjSelTotal(ObjSelTotal);

        }
        if (btnName == 'Lab Issue') {
            localStorage.removeItem('pktId');
            const updatedData = pktidArray?.map(item => ({
                PKTID: item,
                VALIDATIONTYPE: 'VALIDATION_LAB'
            }));

            let ObjJsonDet = {
                jsonObj1: updatedData,
                SPName: "API_PacketValidation"
            };

            let DetStock = await DynamicFetchNew(ObjJsonDet);
            setPktErrData(DetStock);

            if (DetStock?.length > 0) {
                setShowModal(true);
            }
            else {
                const NewPktId = pktidArray?.join(',');
                localStorage.setItem('pktId', NewPktId);
                navigate('/LabIssue');
            }

        }
        if (btnName == 'Jangad Issue') {
            localStorage.removeItem('pktId');
            const updatedData = pktidArray?.map(item => ({
                PKTID: item,
                VALIDATIONTYPE: 'VALIDATION_JANGAD'
            }));

            let ObjJsonDet = {
                jsonObj1: updatedData,
                SPName: "API_PacketValidation"
            }

            let DetStock = await DynamicFetchNew(ObjJsonDet);
            setPktErrData(DetStock);

            if (DetStock?.length > 0) {
                setShowModal(true);
            }
            else {
                const NewPktId = pktidArray?.join(',');
                localStorage.setItem('pktId', NewPktId);
                navigate('/JangadIssue');
            }
        }
        if (btnName == 'Estimate Issue') {
            localStorage.removeItem('pktId');
            const updatedData = pktidArray?.map(item => ({
                PKTID: item,
                VALIDATIONTYPE: 'Validation_ESTIMATE'
            }));

            let ObjJsonDet = {
                jsonObj1: updatedData,
                SPName: "API_PacketValidation"
            }

            let DetStock = await DynamicFetchNew(ObjJsonDet);
            setPktErrData(DetStock);

            if (DetStock?.length > 0) {
                setShowModal(true);
            }
            else {
                const NewPktId = pktidArray?.join(',');
                localStorage.setItem('pktId', NewPktId);
                navigate('/EstimateIss');
            }
        }
        if (btnName == 'Sale Issue') {
            localStorage.removeItem('pktId');
            const updatedData = pktidArray?.map(item => ({
                PKTID: item,
                VALIDATIONTYPE: 'VALIDATION_SAL'
            }));

            let ObjJsonDet = {
                jsonObj1: updatedData,
                SPName: "API_PacketValidation"
            }

            let DetStock = await DynamicFetchNew(ObjJsonDet);
            setPktErrData(DetStock);

            if (DetStock?.length > 0) {
                setShowModal(true);
            }
            else {
                const NewPktId = pktidArray?.join(',');
                localStorage.setItem('pktId', NewPktId);
                navigate('/SaleEntry');
            }
        }
        if (btnName === 'Price/Disc Upd') {
            localStorage.removeItem('pktId');
            const updData = pktidArray?.map(item => ({
                PKTID: item,
                VALIDATIONTYPE: 'VALIDATION_PRICE'
            }));

            let ObjJsonDet = {
                jsonObj1: updData,
                SPName: "API_PacketValidation"
            }

            let DetStock = await DynamicFetchNew(ObjJsonDet);
            setPktErrData(DetStock);

            if (DetStock?.length > 0) {
                setShowModal(true);
            }
            else {
                const NewPktID = pktidArray?.join(',');
                localStorage.setItem('pktId', NewPktID);
                navigate('/PriceDiscUpd');
            }
        }

        if (btnName === 'Price Pending') {
            debugger
            localStorage.removeItem('pktId');
            const updData = pktidArray?.map(item => ({
                PKTID: item
            }));

            let ObjJsonDet = {
                jsonObj1: updData,
                SPName: "API_PktPricePending"
            }

            await dispatch(addData(ObjJsonDet)).then(() => {
                if (props.refreshData) {
                    props.refreshData();
                } else {
                    window.location.reload();
                }
            });

        }

        if (btnName === 'Data Upd Entry') {
            localStorage.removeItem('pktId');
            const updData = pktidArray?.map(item => ({
                PKTID: item,
                VALIDATIONTYPE: 'VALIDATION_DATAUPD'
            }));

            let ObjJsonDet = {
                jsonObj1: updData,
                SPName: "API_PacketValidation"
            }

            let DetStock = await DynamicFetchNew(ObjJsonDet);
            setPktErrData(DetStock);

            if (DetStock?.length > 0) {
                setShowModal(true);
            }
            else {
                const NewPktID = pktidArray?.join(',');
                localStorage.setItem('pktId', NewPktID);
                navigate('/DataUpdEntry');
            }
        }
        if (btnName === 'Filter') {
            setopenPacketSearchCom(true)
        }
        if (btnName == 'Barcode') {
            const updatedData = pktidArray?.map(item => ({
                PKTID: item
            }));
            let ObjJsonDet = {
                jsonObj1: updatedData,
                SPName: "API_Barcode"
            }
            let DetStock = await DynamicFetchNew(ObjJsonDet);
            if (BarSetting === undefined) {
                AlertPopup.warningPopup("Barsetting Data Not Found");
            }
            else {
                let barCodeStr = '';
                DetStock.forEach(x => {
                    let BarCode = BarSetting[0]?.CODE;
                    const regex = /#(.*?)#/g;
                    BarCode?.match(regex)?.forEach(code => {
                        code = code.replace(/#/g, '')
                        BarCode = BarCode.replace(`#${code}#`, `${x[code]}`);
                    })
                    barCodeStr += BarCode + '\n';
                });
                const blob = new Blob([barCodeStr], { type: 'text/plain' });
                const filename = 'barcodes.txt';

                const downloadUrl = URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = downloadUrl;
                link.download = filename;
                link.click();
                URL.revokeObjectURL(downloadUrl);
            }
        }
        if (btnName == 'CertBarCode') {
            const updatedData = pktidArray?.map(item => ({
                PKTID: item
            }));
            let ObjJsonDet = {
                jsonObj1: updatedData,
                SPName: "API_Barcode"
            }
            let DetStock = await DynamicFetchNew(ObjJsonDet);
            if (CertBarSetting === undefined) {
                AlertPopup.warningPopup("Certi Barsetting Data Not Found");
            }
            else {
                let barCodeStr = '';
                DetStock.forEach(x => {
                    let BarCode = CertBarSetting[0]?.CODE;
                    const regex = /#(.*?)#/g;
                    BarCode?.match(regex)?.forEach(code => {
                        code = code.replace(/#/g, '')
                        BarCode = BarCode.replace(`#${code}#`, `${x[code]}`);
                    })
                    barCodeStr += BarCode + '\n';
                });
                const blob = new Blob([barCodeStr], { type: 'text/plain' });
                const filename = 'Certibarcode.txt';

                const downloadUrl = URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = downloadUrl;
                link.download = filename;

                link.click();

                URL.revokeObjectURL(downloadUrl);
            }
        }
        if (btnName == 'DeleteAll') {

            const updatedData = pktidArray?.map(item => ({
                PKTID: item
            }));

            let ObjJsonDet = {
                jsonObj1: updatedData,
                SPName: pageName == 'STONESEARCH' ? "API_StnSearchPktDel" : "API_PktIdAllDetailDelete"
            }
            // dispatch(addData(ObjJsonDet));

            let res = await ConfirmPopupBig('Are You Sure You Want to Delete ??');
            if (res) {
                dispatch(addData(ObjJsonDet)).then(() => {
                    if (props.refreshData) {
                        props.refreshData();
                    } else {
                        window.location.reload();
                    }
                });
            }

        }
        if (btnName == 'IsActive') {
            const updatedData = pktidArray?.map(item => ({
                PKTID: item
            }));
            let ObjJsonDet = {
                jsonObj1: updatedData,
                SPName: "API_IsActivePktMastUpd"
            }
            // dispatch(addData(ObjJsonDet, ''));
            await dispatch(addData(ObjJsonDet)).then(() => {
                if (props.refreshData) {
                    props.refreshData();
                } else {
                    window.location.reload();
                }
            });
        }
        if (btnName == 'Price Per Carat') {
            const updatedData = pktidArray?.map(item => ({
                PKTID: item
            }));
            let ObjJsonDet = {
                jsonObj1: updatedData,
                SPName: "API_IsPricePerCrtPktMastUpd"
            }
            // dispatch(addData(ObjJsonDet, ''));
            await dispatch(addData(ObjJsonDet)).then(() => {
                if (props.refreshData) {
                    props.refreshData();
                } else {
                    window.location.reload();
                }
            });
        }

        if (btnName == 'NonCert Issue') {
            localStorage.removeItem('pktId');
            const updatedData = pktidArray?.map(item => ({
                PKTID: item,
                VALIDATIONTYPE: 'Validation_NONCERT'
            }));

            let ObjJsonDet = {
                jsonObj1: updatedData,
                SPName: "API_PacketValidation"
            };

            let DetStock = await DynamicFetchNew(ObjJsonDet);
            setPktErrData(DetStock);

            if (DetStock?.length > 0) {
                setShowModal(true);
            }
            else {
                const NewPktId = pktidArray?.join(',');
                localStorage.setItem('pktId', NewPktId);
                navigate('/NonCertIssue');
            }
        }
        if (btnName == 'MixOut Entry') {
            localStorage.removeItem('pktId');
            const updatedData = pktidArray?.map(item => ({
                PKTID: item,
                VALIDATIONTYPE: 'Validation_MIXOUT'
            }));

            let ObjJsonDet = {
                jsonObj1: updatedData,
                SPName: "API_PacketValidation"
            }

            let DetStock = await DynamicFetchNew(ObjJsonDet);
            setPktErrData(DetStock);

            if (DetStock?.length > 0) {
                setShowModal(true);
            }
            else {
                const NewPktId = pktidArray?.join(',');
                localStorage.setItem('pktId', NewPktId);
                navigate('/MixOutEntry');
            }
        }
    }

    const cleanMobileNumber = (mobile) => {
        // Remove all non-digit characters
        const digits = mobile.replace(/\D/g, '');

        // Ensure it starts with country code (e.g., '91')
        if (digits.length === 10) {
            return '91' + digits; // Assume it's an Indian number
        } else if (digits.length === 12 && digits.startsWith('91')) {
            return digits;
        } else {
            return null; // Invalid number
        }
    };

    const handleDone = async () => {
        try {
            // Filter selected rows with valid mobile number
            const selectedRows = SelectedrowAcc?.filter(x => x.SELECTED === true && x.MOBILE_NO);

            if (selectedRows.length === 0) {
                alert("Please select at least one row with a valid mobile number.");
                return;
            }

            for (const row of selectedRows) {
                // Clean the mobile number and add country code
                const rawMobile = row.MOBILE_NO;
                const mobile = "91" + rawMobile.replace(/\D/g, ''); // e.g., 91 + 9876543210

                const url = `https://messagesapi.co.in/chat/sendFileWithMessage?id=bd746da43a0e4942a48d7fa329c98f4c&phone=${mobile}&message=Hello How do you do?&file=https://pdfobject.com/pdf/sample.pdf&name=office`;

                try {
                    const response = await fetch(url, { method: "GET" });
                    const data = await response.json();

                    if (!data.success) {
                        console.warn(`Failed to send message to ${mobile}`);
                    }
                } catch (err) {
                    console.error(`Error sending message to ${mobile}:`, err);
                }
            }

            alert("Message sending process completed.");
            setShowAccSearchModal(false);
        } catch (error) {
            console.error("API call failed:", error);
            alert("Something went wrong while sending the messages.");
        }
    };


    const handleOpenModal = () => {
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpenDemo(false);
    };

    const moreIndex = btnValues.indexOf("More");

    const [showPopup, setShowPopup] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    // ✅ Handle screen resize
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const handleCloseModalVideoLink = () => {
        setisModalVideoLink(false);
    };

    const handleExcludePackets = () => {
        let pktidArray = Array.isArray(Selectedrow) && Selectedrow?.map(obj => obj.SELECTED === true && obj.PKTID);
        const errorPktIds = PktErrData?.map(row => row.PKTID);
        const remainingPktIds = pktidArray?.filter(pktId => !errorPktIds.includes(pktId))?.join(',');

        localStorage.setItem('pktId', remainingPktIds);
        if (pagebtnNaviName == "Lab Issue")
            navigate('/LabIssue');
        else if (pagebtnNaviName == "Jangad Issue")
            navigate('/JangadIssue');
        else if (pagebtnNaviName == "Sale Issue")
            navigate('/SaleEntry');
        else if (pagebtnNaviName == "Price/Disc Upd")
            navigate('/PriceDiscUpd');
        else if (pagebtnNaviName == "Data Upd Entry")
            navigate('/DataUpdEntry');
    };

    const getAllData = () => {

        if (props.DataSrc) {
            setobjDs(JSON.parse(JSON.stringify(props.DataSrc || '[]')));
        }

        // const savedData = localStorage.getItem('PktSearchData');
        // if (savedData) {
        //     const parsedData = JSON.parse(savedData);
        //     setSelectedrow(parsedData);
        //     Selectedrow = parsedData;
        //     GetselectedRow(parsedData);
        // }
        // if (localStorage.getItem('PktSearchData')) {
        //     setSelectedrow(JSON.parse(localStorage.getItem('PktSearchData')))
        //     Selectedrow = JSON.parse(localStorage.getItem('PktSearchData'));
        //     GetselectedRow(JSON.parse(localStorage.getItem('PktSearchData')))
        // }
    }

    const [options, setOptions] = useState([]);
    const [OptLoc, setOptLoc] = useState([]);
    const [OptAcc, setOptAcc] = useState([]);
    const [MfgParoptions, setMfgParOptions] = useState([]);
    const [userRole, setuserRole] = useState('')

    const fetchModalData = async () => {
        const ObjJson = {
            jsonObj1: [{}],
            SPName: "API_AccMastSearch"
        };
        try {
            const response = await DynamicFetchNew(ObjJson);
            setOptAcc(response || []);
        } catch (error) {
            console.error("Failed to fetch modal data:", error);
        }
    };

    useEffect(() => {

        const fetchData = async () => {
            let GetDropDown = DropDown.SPARMAST?.filter(x => x.Ac_Type == 'SPAR');
            setOptions(GetDropDown);

            let GetDropDownMfgPar = DropDown.SPARMAST?.filter(x => x.Ac_Type == 'STKPARTY');
            setMfgParOptions(GetDropDownMfgPar);

            let GetDropDownLot = DropDown.LOTMAST;
            setOptionLotDet(GetDropDownLot);

            let GetLocation = DropDown.LOCATION;
            setOptLoc(GetLocation);

            if (DropDown.USERS) {
                let UserRole = DropDown.USERS.find(x => x.UserName == JSON.parse(localStorage.getItem('loginUserDetail'))?.UserName);
                if (UserRole) {
                    setuserRole(DropDown.ROLES.find(x => x.ValueKey == UserRole.RoleId)?.DisplayName)
                    setParty({ Code: UserRole.AC_CODE })
                }
            }
        };
        if (DropDown) {
            fetchData();
        }

    }, [DropDown]);
    ///For Cell Color 
    function getCellTheme(dataRow, columnKey) {
        let colorProperty = Object.keys(dataRow)?.filter(x => x?.endsWith('_COLOR'))
        for (let x of colorProperty) {
            if (x?.split('_COLOR')?.length > 0) {
                if (dataRow[x] && columnKey == x?.split('_COLOR')[0]) {
                    return {
                        bgCell: dataRow[x]?.toLowerCase()
                    }
                }
            }
        }
    }

    const handleSwitchChange = () => {
        setShowTotal(!showTotal);
    };

    const getActionButton = (dataRow, columnKey) => {
        if (columnKey?.toLowerCase() === "certno") {
            return {
                ...GridActionButton.LinkButton,
                title: dataRow.REPORTLINK,
                onClick: () => {
                    window.open(dataRow.REPORTLINK, "_blank");
                },
            };
        }
        else {
            return undefined;
        }
    };

    const selectedOptionTemplate = (option, props) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                    <div>{option?.Name}</div>
                </div>
            );
        }

        return <span>{props?.placeholder}</span>;
    };
    const OptionTemplate = (option) => {
        return (
            <div className="flex align-items-center">
                <div>{option?.Name}</div>
            </div>
        );
    };

    const displayType = (vType) => {
        setViewType(vType)
        changeContentHeight()
    }

    function PreloadImages(imageUrls) {
        const promises = imageUrls?.map((url, index) =>
            new Promise((resolve, reject) => {
                const img = new Image();
                img.src = url;
                img.onload = () => {
                    resolve();
                };
                img.onerror = reject;
            })
        );
        Promise.all(promises).catch(() => {
        });
    }

    useEffect(() => {
        if (objDs && (ViewType == 'CardView' || ViewType == 'BestPairCardView')) {
            PreloadImages(objDs.slice(1, 100)?.map(x => x.PHOTOROTED))
        }
    }, [objDs, ViewType])

    useEffect(() => {
        if (objDs) {
            const newItems = objDs.slice(0, 20);
            visibleItems = [...newItems];
            setVisibleItems([...visibleItems]);
        }
    }, [ViewType, objDs])

    const handleVideoError = (index) => {
        setErrorStatus((prevStatus) => ({ ...prevStatus, [index]: true }));
    };

    const fetchMoreData = () => {
        const newIndex = visibleItems.length + itemsPerPage;
        const newItems = objDs.slice(visibleItems.length, newIndex);
        visibleItems = [...visibleItems, ...newItems];
        setVisibleItems([...visibleItems]);
    };

    useEffect(() => {
        window.addEventListener('resize', (e) => {
            changeContentHeight()
        })
        changeContentHeight()
    }, []);

    const changeContentHeight = () => {
        let StoneStatusHeight = document.querySelector('.StoneStatus')?.clientHeight;
        let totalDivHeight = document.querySelector('.totalDiv')?.clientHeight;
        let btndivHeight = document.querySelector('.btndiv')?.clientHeight;
        setcardViewHeight(window.innerHeight - 40 - (StoneStatusHeight + totalDivHeight + btndivHeight + 55))
    };

    const selectCard = (row, checked) => {
        GetselectedRow(Selectedrow, { ...row, SELECTED: checked })
    };

    const handleOpenWhatsApp = (phoneNumber) => {
        if (!phoneNumber) {
            console.error("Invalid phone number");
            return;
        }

        let PktIDList = Array.isArray(Selectedrow) && Selectedrow?.filter(obj => obj.SELECTED === true && obj.PKTID)?.map(obj => obj.PKTID);
        // const message = PktIDList?.length > 1 ? PktIDList.join(',') : PktIDList; /////Coma Saperated Male
        const message = PktIDList?.length > 1 ? PktIDList?.join('\n') : PktIDList; /////blow PKTID Male
        let whatsappURL = `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURI(message)}&app_absent=0`;
        // let whatsappURL = `https://messagesapi.co.in/chat/sendFileWithMessage?id=ad7838b8e5b94b978757bb5ce9b634f9&phone=919931531588,919771440683&message=Hello How do you do?&file=https://pdfobject.com/pdf/sample.pdf&name=OnePlus9`;

        window.open(whatsappURL);
    }

    const handleLocDoubleClick = async (rowData) => {
        let pktidArray = Array.isArray(Selectedrow) && Selectedrow?.map(obj => obj.SELECTED === true && obj.PKTID);
        const updatedData = pktidArray?.map(item => ({
            PKTID: item,
            LOC_CODE: rowData?.CODE
        }));
        let ObjJsonDet = {
            jsonObj1: updatedData,
            SPName: "API_LocationUpd"
        }
        await dispatch(addData(ObjJsonDet))

        // .then(() => {
        //     if (props.refreshData) {
        //         props.refreshData();
        //     } else {
        //         window.location.reload();
        //     }
        // });
        setShowLocSearchModal(false);
    }
    const handleAccDoubleClick = async (rowData) => {
        let pktidArray = Array.isArray(Selectedrow) && Selectedrow?.map(obj => obj.SELECTED === true && obj.PKTID);
        const updatedData = pktidArray?.map(item => ({
            PKTID: item,
            LOC_CODE: rowData?.CODE
        }));
        let ObjJsonDet = {
            jsonObj1: updatedData,
            SPName: "API_LocationUpd"
        }
        await dispatch(addData(ObjJsonDet)).then(() => {
            if (props.refreshData) {
                props.refreshData();
            } else {
                window.location.reload();
            }
        });
        setShowLocSearchModal(false);
    }
    const videoContent = useMemo(() => {
        return <>
            {
                ViewType == 'CardView' &&
                <>
                    {
                        visibleItems?.map((x, i) => {
                            return <div className='col-6 col-lg-3 col-xxl-2' key={i}>
                                <div className="card border-0">
                                    <div className='d-flex justify-content-end me-2 mt-1'>
                                        <input className="form-check-input textBoxCss me-1" type="checkbox" value="" id="flexCheckChecked" checked={Selectedrow?.map(a => a.PKTID).includes(x.PKTID)} onChange={(e) => selectCard(x, e.target.checked)} /> {x.PKTID}
                                    </div>
                                    <div className="card-body p-1">
                                        <div className="video-container" style={{ height: '260px', backgroundColor: '#C2C1C8' }}>
                                            <div className='d-flex BackClr'>
                                                <div className="DiamondTyp">{x.DIAMONDTYPE}</div>
                                                <div className="Lab">{x.LAB}</div>
                                            </div>
                                            {!errorStatus[i] ? (
                                                <>
                                                    <img
                                                        src={x.PHOTOROTED}
                                                        alt="Diamond"
                                                        style={{
                                                            width: '100%',
                                                            height: '100%',
                                                            objectFit: 'cover',
                                                            minHeight: '100%'
                                                        }}
                                                        onError={() => handleVideoError(i)}
                                                    />
                                                </>
                                            ) : (
                                                <div
                                                    className="d-flex justify-content-center align-items-center"
                                                    style={{ height: '260px' }}
                                                >
                                                    <p>Image Not Found</p>
                                                </div>
                                            )}
                                        </div>
                                        <p className="card-Heading m-0 text-cente pt-1">{x.STONEDETAIL}</p>
                                        {/* <OverlayTrigger placement="bottom" overlay={<Tooltip id={`tooltip-${x.COU_CODE}`}>{x.COU_NAME}</Tooltip>} > */}
                                        <div className='d-flex justify-content-between align-items-center my-1'>
                                            {/* <p className="card-text m-0"> <FlagIcon code={x.COU_CODE} size={13} width={20} /> </p> */}
                                            <div>
                                                <p className='card-text ms-2'>IGI {x.CERTNO}</p>
                                            </div>
                                            <div>
                                                <span className='card-text ms-2'>{x.COU_NAME}/</span>
                                                <span className='card-text ms-2'>{x.LOC_NAME}</span>
                                            </div>
                                        </div>
                                        {/* </OverlayTrigger>  */}
                                        <div className='d-flex justify-content-between my-1'>
                                            <p className="card-text m-0"><span style={{ color: 'red' }}>T:</span> {x.TABLE_PER}</p>
                                            <p className="card-text m-0"><span style={{ color: 'red' }}>D: </span>{x.TOTDEPTH_PER}</p>
                                            <p className="card-text m-0"><span style={{ color: 'red' }}>RT:</span> {x.RATIO}</p>
                                            <p className="card-text m-0"><span style={{ color: 'red' }}>M:</span> {x.MEASUREMENTS}</p>
                                        </div>

                                        <div className='d-flex justify-content-between'>
                                            <p className="card-text m-0">${(x.RATE).toFixed(2)}/ct</p>
                                            <p className="m-0 Disc-text" style={{ color: '#1a7431', fontSize: '12px', fontWeight: 800 }}>-{(x.DISC).toFixed(2)}%</p>
                                            <p className="m-0 fs-6 fw-bolder" style={{ color: 'maroon', fontSize: '12px', fontWeight: 600 }}>${(x.AMT).toFixed(2)}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        })
                    }
                </>
            }
        </>
    }, [ViewType, visibleItems, errorStatus, videoRef, handleMouseOver, handleMouseOut, Selectedrow])

    const [chartFor, setchartFor] = useState('I_CARAT')

    const getChartData = (fieldName, ordBy) => {
        let allData = Object.values(
            objDs?.reduce((acc, item) => {
                const fieldLabel = item[fieldName];
                if (!acc[fieldLabel]) {
                    acc[fieldLabel] = {
                        FIELDLABEL: fieldLabel,
                        FIELDDATA: 0,
                        FIELDTYP: "number",
                        TYP: chartFor,
                        ORD: item[ordBy]
                    };
                }
                acc[fieldLabel].FIELDDATA += item[chartFor];
                return acc;
            }, {})
        ).sort((a, b) => a.ORD - b.ORD);
        let sortedData = allData;
        if (chartFor == 'I_CARAT') {
            const total = allData.reduce((sum, x) => sum + x.FIELDDATA, 0);

            sortedData = allData?.map(x => ({
                ...x,
                FIELDDATA: total > 0 ? ((x.FIELDDATA / total) * 100).toFixed(2) : 0
            }))
        } else {
            sortedData = allData?.map(x => ({
                ...x,
                FIELDDATA: String(x.FIELDDATA)
            }))
        }
        return sortedData;
    }
    const chartContent = useMemo(() => {


        const changeChartForType = (type) => {
            setchartFor()
            setTimeout(() => {
                setchartFor(type)
            }, 0);
        }
        return <>
            {
                ViewType == 'ChartView' &&
                <>
                    <div>
                        <button type="button" class="btn btn-sm btn-outline-primary F12 ml-md-2 me-2 mb-2" onClick={() => changeChartForType('I_CARAT')}>Carat</button>
                        <button type="button" class="btn btn-sm btn-outline-primary F12 ml-md-2 me-2 mb-2" onClick={() => changeChartForType('I_PCS')}>Pcs</button>
                    </div>
                    <div className="row px-2">
                        <div className="col-6">
                            {
                                chartFor && <VerticalChart chartData={getChartData('Q_NAME', 'Q_ORD') || []} symbol={chartFor == 'I_PCS' ? "" : "%"} />
                            }
                        </div>
                        <div className="col-6">
                            {
                                chartFor && <VerticalChart chartData={getChartData('CT_NAME', 'CT_ORD') || []} symbol={chartFor == 'I_PCS' ? "" : "%"} />
                            }
                        </div>
                        <div className="col-6">
                            {
                                chartFor && <VerticalChart chartData={getChartData('PO_NAME', 'PO_ORD') || []} symbol={chartFor == 'I_PCS' ? "" : "%"} />
                            }
                        </div>
                        <div className="col-6">
                            {
                                chartFor && <VerticalChart chartData={getChartData('SY_NAME', 'SY_ORD') || []} symbol={chartFor == 'I_PCS' ? "" : "%"} />
                            }
                        </div>
                        <div className="col-12">
                            {
                                chartFor && <VerticalChart chartData={getChartData('C_NAME', 'C_ORD') || []} symbol={chartFor == 'I_PCS' ? "" : "%"} />
                            }

                        </div>
                    </div>
                </>
            }
        </>
    }, [ViewType, objDs, chartFor])


    const bestPairContent = useMemo(() => {
        const groupBy = (array, key) => {
            return array.reduce((result, item) => {
                if (item[key] !== 0 && item[key] !== undefined && item[key] !== null) {
                    if (!result[item[key]]) {
                        result[item[key]] = [];
                    }
                    result[item[key]].push(item);
                }
                return result;
            }, {});
        };


        const groupedItems = groupBy(objDs, 'PAIRROWGRP');


        return (
            <>
                {ViewType === 'BestPairCardView' &&
                    Object.keys(groupedItems)?.map((groupKey) => (

                        <div key={groupKey}>
                            {/* Group Header */}
                            <div style={{ backgroundColor: '#edf6f9' }}>
                                {/* <h2 className="m-0 text-center ">{groupKey}</h2> */}
                                <p className="py-3 m-0 text-center" style={{ color: '#023e8a', fontSize: "17px", fontWeight: 600 }}>{groupedItems[groupKey][0].STONEDETAIL}</p>
                            </div>

                            {/* Group Items */}
                            <div className="row">
                                {groupedItems[groupKey]?.map((x, i) => (
                                    <div className='col-6 col-lg-3 col-xxl-2' key={i}>
                                        <div className="card border-0">
                                            <div className='me-2 mt-1 text-center'>
                                                <input className="form-check-input textBoxCss me-1"
                                                    type="checkbox"
                                                    value=""
                                                    id="flexCheckChecked"
                                                    checked={Selectedrow?.map(a => a.PKTID).includes(x.PKTID)}
                                                    onChange={(e) => selectCard(x, e.target.checked)}
                                                />
                                                {x.PKTID}
                                            </div>
                                            <div className="card-body p-1">
                                                <div className="video-container" style={{ height: '260px', backgroundColor: '#C2C1C8' }}>
                                                    <div className='d-flex BackClr'>
                                                        {/* <div className="DiamondTyp">{x.DIAMONDTYPE}</div> */}
                                                        <div className="Lab">{x.LAB}</div>
                                                    </div>
                                                    {!errorStatus[i] ? (
                                                        <>
                                                            <img
                                                                src={x.PHOTOROTED}
                                                                alt="Diamond"
                                                                style={{
                                                                    width: '100%',
                                                                    height: '100%',
                                                                    objectFit: 'cover',
                                                                    minHeight: '100%'
                                                                }}
                                                                onError={() => handleVideoError(i)}
                                                            />
                                                        </>
                                                    ) : (
                                                        <div
                                                            className="d-flex justify-content-center align-items-center"
                                                            style={{ height: '260px' }}
                                                        >
                                                            <p>Image Not Found</p>
                                                        </div>
                                                    )}
                                                </div>
                                                {/* <p className="card-Heading m-0 text-center pt-1">{x.STONEDETAIL}</p> */}
                                                <div className='d-flex justify-content-center align-items-center my-1'>
                                                    <p className="card-text m-0">
                                                        <FlagIcon code={x.COU_CODE} size={13} width={20} />
                                                    </p>
                                                    <p className='card-text ms-2'>{x.LOC_NAME}</p>
                                                </div>
                                                <div className='d-flex justify-content-between my-1'>
                                                    <p className="card-text m-0"><span style={{ color: 'red' }}>T:</span> {x.TABLE_PER}</p>
                                                    <p className="card-text m-0"><span style={{ color: 'red' }}>D: </span>{x.TOTDEPTH_PER}</p>
                                                    <p className="card-text m-0"><span style={{ color: 'red' }}>R:</span> {x.RATIO}</p>
                                                    <p className="card-text m-0"><span style={{ color: 'red' }}>M:</span> {x.MEASUREMENTS}</p>
                                                </div>
                                                <div className='d-flex justify-content-between'>
                                                    <p className="card-text m-0">${(x.RATE).toFixed(2)}/ct</p>
                                                    <p className="m-0 Disc-text" style={{ color: '#1a7431', fontSize: '12px', fontWeight: 800 }}>-{(x.DISC).toFixed(2)}%</p>
                                                    <p className="m-0 fs-6 fw-bolder" style={{ color: 'maroon', fontSize: '12px', fontWeight: 600 }}>${(x.AMT).toFixed(2)}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))
                }
            </>
        );
    }, [ViewType, visibleItems, errorStatus, videoRef, handleMouseOver, handleMouseOut, Selectedrow]);

    const fetchOfferCountData = async (rowData) => {
        try {

            const ObjJson = {
                jsonObj1: [{ I_DATE: "", JNO: 0 }],
                SPName: "API_OfferEntDoneDisp"
            };

            const res = await DynamicFetchNew(ObjJson);

            // Filter only rows where PKTID matches
            const filtered = res?.filter(x => x?.PKTID === rowData.PKTID);

            setOfferCountRowData(filtered);
            setIsOfferCountModal(true);
        } catch (error) {
            console.error("Error fetching offer count data:", error);
        }
    };


    const handlePKTIDClick = (rowData, column) => {
        if (column === 'STNSTATUS' && rowData?.PKTID) {
            setisModalVideoLink(true);
            setVideoLinkRow([rowData]);
        }

        if (column === 'PKTIDOFFERCOUNT' && rowData?.PKTID) {
            fetchOfferCountData(rowData);

        };
    }

    const OnPartyFilter = (e) => {
        let PCode = e.target.value;
        setParty(PCode)
        if (PageName == 'PACKETSEARCH') {
            let filterStnStatus = props.DataSrc;
            if (PCode?.Code) {
                filterStnStatus = props.DataSrc?.filter(
                    item => item.PAC_CODE == Number(PCode?.Code)
                );
                setobjDs(JSON.parse(JSON.stringify(filterStnStatus) || '[]'));
                setTmpobjDs(JSON.parse(JSON.stringify(filterStnStatus) || '[]'));
            }
            else {
                setobjDs(JSON.parse(JSON.stringify(filterStnStatus) || '[]'));
                setTmpobjDs(JSON.parse(JSON.stringify(filterStnStatus) || '[]'));
            }
        }

    }

    const handleFilterApply = (filteredData) => {
        setobjDs(filteredData); // updates data in parent
    };

    const handleClearFilter = () => {
        setobjDs(JSON.parse(JSON.stringify(props.DataSrc))); // restore the original data
    };

    const handlePassChange = (pass) => {
        if (pass == MainPassword) {
            setIsDeletebtnShow(true);
        }
        else {
            setIsDeletebtnShow(false);
        }
    }

    const gridHeight = useAutoAdjustHeight(showTotal, objTotal);
    const gridContent = useMemo(() => {
        return <>
            {
                ViewType == 'GridView' &&
                // objDs && objDs?.length > 0 && objViewPara && objViewPara?.length > 0 &&
                objViewPara && objViewPara?.length > 0 &&
                <GlidGrid
                    data={objDs}
                    columns={objViewPara}
                    height={`${gridHeight}px`}
                    getCellTheme={getCellTheme}
                    GetselectedRow={GetselectedRow}
                    ActionButton={getActionButton}
                    getaction
                    headerHeight={30}
                    ExcelGet={pageName}
                    ViewparaName={pageName}
                    onCellDoubleClicked={(rowData, column) => handlePKTIDClick(rowData, column)}
                    onFilterApply={handleFilterApply}
                    onClearFilter={handleClearFilter}
                />
            }
        </>
    }, [ViewType, objDs, objViewPara, gridHeight])

    return (
        <>
            <div className='bg-white gridTopHeight2' style={{ zIndex: 100, top: PageName === 'STONESEARCH' ? 85 : 35 }}>
                {
                    (objTotal && ObjSelTotal && showTotal) &&
                    <div className='row totalDiv px-lg-3 position-sticky-top-0 CardComp pt-2'>
                        <div className='col-lg-2 col-md-4 col-6'>
                            <div className="card border-0 pe-2">
                                <div className="card-body d-flex align-items-center justify-content-between totaldivCol">
                                    <div>
                                        <p className='f-title'>Pcs</p>
                                    </div>
                                    <div className='text-end RedColor' style={{ color: "#d90429" }}>
                                        <p className='m-0 '>{(objTotal?.I_PCS || 0)}</p>
                                        <p className='m-0 '>{(ObjSelTotal?.I_PCS || 0)}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 col-md-4 col-6'>
                            <div className="card border-0 pe-2">
                                <div className="card-body d-flex align-items-center justify-content-between totaldivCol">
                                    <div>
                                        <p className='f-title'>Carat</p>
                                    </div>
                                    <div className='text-end RedColor' style={{ color: "#3c096c" }}>
                                        <p className='m-0 '>{(objTotal?.I_CARAT || 0.00).toFixed(2)}</p>
                                        <p className='m-0 '>{(ObjSelTotal?.I_CARAT || 0.00).toFixed(2)}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 col-md-4 col-6'>
                            <div className="card border-0 pe-2">
                                <div className="card-body d-flex align-items-center justify-content-between totaldivCol">
                                    <div>
                                        <p className='f-title'>Avg Rap</p>
                                    </div>
                                    <div className='text-end RedColor' style={{ color: "#a53860" }}>
                                        <p className='m-0  '>$ {(objTotal?.ORATE || 0).toFixed(0)}</p>
                                        <p className='m-0  '>$ {(ObjSelTotal?.ORATE || 0).toFixed(0)}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 col-md-4 col-6'>
                            <div className="card border-0 pe-2">
                                <div className="card-body d-flex align-items-center justify-content-between totaldivCol">
                                    <div>
                                        <p className='f-title'>Disc</p>
                                    </div>
                                    <div className='text-end RedColor' style={{ color: "#036666" }}>
                                        <p className='m-0 '>{(objTotal?.DISC || 0.00).toFixed(2)}</p>
                                        <p className='m-0 '>{(ObjSelTotal?.DISC || 0.00).toFixed(2)}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 col-md-4 col-6'>
                            <div className="card border-0 pe-2">
                                <div className="card-body d-flex align-items-center justify-content-between totaldivCol">
                                    <div>
                                        <p className='f-title'>Avg Price</p>
                                    </div>
                                    <div className='text-end RedColor' style={{ color: "#7d4f50" }}>
                                        <p className='m-0 '>$ {(objTotal?.RATE || 0.00).toFixed(2)}</p>
                                        <p className='m-0 '>$ {(ObjSelTotal?.RATE || 0.00).toFixed(2)}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 col-md-4 col-6'>
                            <div className="card border-0 pe-2">
                                <div className="card-body d-flex align-items-center justify-content-between totaldivCol">
                                    <div>
                                        <p className='f-title'>Value</p>
                                    </div>
                                    <div className='text-end RedColor' style={{ color: "#0466c8" }}>
                                        <p className='m-0 '>$ {(objTotal?.AMT || 0.00).toFixed(2)}</p>
                                        <p className='m-0 '>$ {(ObjSelTotal?.AMT || 0.00).toFixed(2)}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }

                <div className="btndiv px-lg-3 LabIssDropDown pt-lg-3 p-2">
                    <div className="row">
                        <div className="col-12">
                            <div className="d-flex flex-wrap align-items-center w-100 position-relative pb-2">
                                {btnValues?.map((value, index) => {
                                    const isAfterMore = index > moreIndex;

                                    if (value === "DeleteAll" && !IsDeletebtnShow) {
                                        return null;
                                    }

                                    // 🔹 Mobile View — Show Filter, Refresh, and More only
                                    if (isMobile) {
                                        if (value === "Filter" || value === "Refresh") {
                                            return (
                                                <button
                                                    key={index}
                                                    type="button"
                                                    className={`savepanelBtn ${value === "Filter" ? "btn-Search btn-sm" : "btnRefresh"} ml-md-2 me-2 mb-1`}
                                                    onClick={() => handleSave(value)}
                                                >
                                                    {value === "Filter" && <RiFilterFill className='me-1' size={20} />}
                                                    {value === "Refresh" && <IoMdRefresh className='me-1' size={20} />}
                                                    {value}
                                                </button>
                                            );
                                        }

                                        if (value === "More...") {
                                            return (
                                                <React.Fragment key={index}>
                                                    <button
                                                        type="button"
                                                        className="savepanelBtn btn-primary ml-md-2 me-2 mb-1"
                                                        onClick={() => setShowPopup(true)}
                                                    >
                                                        {value}
                                                    </button>

                                                    {/* ✅ Full Bootstrap-style Modal */}
                                                    {showPopup && (
                                                        <div
                                                            className="modal fade show d-block"
                                                            tabIndex="-1"
                                                            style={{ backgroundColor: 'rgba(0,0,0,0.3)' }}
                                                        >
                                                            <div className="modal-dialog modal-sm modal-dialog-centered">
                                                                <div className="modal-content rounded-3">
                                                                    {/* 🔹 Header */}
                                                                    <div className="modal-header py-2 px-3">
                                                                        <h6 className="modal-title">Select Action</h6>
                                                                        <button
                                                                            type="button"
                                                                            className="btn-close"
                                                                            onClick={() => setShowPopup(false)}
                                                                        />
                                                                    </div>

                                                                    {/* 🔹 Body */}
                                                                    <div
                                                                        className="modal-body px-3 py-2"
                                                                        style={{ maxHeight: '250px', overflowY: 'auto' }}
                                                                    >
                                                                        <div className="container-fluid">
                                                                            <div className="row">
                                                                                {btnValues
                                                                                    .slice(moreIndex + 1)
                                                                                    ?.filter(btnText => btnText !== "Filter" && btnText !== "Refresh" && btnText !== "More...")
                                                                                    ?.map((btnText, idx) => (
                                                                                        <div className="col-6 mb-2 px-1" key={idx}>
                                                                                            <button
                                                                                                type="button"
                                                                                                className="savepanelBtn btn-primary w-100 text-center"
                                                                                                onClick={() => {
                                                                                                    handleSave(btnText);
                                                                                                    setShowPopup(false);
                                                                                                }}
                                                                                            >
                                                                                                {btnText}
                                                                                            </button>
                                                                                        </div>
                                                                                    ))}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {/* 🔹 Footer */}
                                                                    <div className="modal-footer py-2 px-3">
                                                                        <button
                                                                            type="button"
                                                                            className="savepanelBtn btn-secondary btn-sm"
                                                                            onClick={() => setShowPopup(false)}
                                                                        >
                                                                            Close
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </React.Fragment>
                                            );
                                        }

                                        return null; // Hide other buttons in mobile view
                                    }

                                    // 🔹 Desktop View — Show all buttons inline
                                    if (value !== "More...") {
                                        return (
                                            <button
                                                key={index}
                                                type="button"
                                                className={`savepanelBtn  ${value === "Filter"
                                                    ? "btn-Search"
                                                    : value === "Refresh"
                                                        ? "btnRefresh"
                                                        : "btn-primary btn-sm"
                                                    } ml-md-2 me-2 mb-1`}
                                                onClick={() => handleSave(value)}
                                            >
                                                {value === "Filter" && <RiFilterFill className='me-1' size={20} />}
                                                {value === "Refresh" && <IoMdRefresh className='me-1' size={20} />}
                                                {value}
                                            </button>
                                        );
                                    }
                                })}

                                {/* 🔽 Page Range Dropdown */}
                                {/* {PageName !== 'PACKETSEARCH' && (
                                    <div className='ps-2 pe-2'
                                        style={{
                                            // width: '180px',
                                            minWidth: window.innerWidth <= 768 ? '50%' : '180px',
                                        }}>
                                        <Dropdown
                                            value={PagingRange}
                                            onChange={(e) => setPagingRange(e.target.value)}
                                            options={PageRange ?? []}
                                            optionLabel="NAME"
                                            placeholder="Select Range"
                                            showClear
                                            // className="w-100"
                                        />
                                    </div>
                                )} */}

                                {/* 🧑 Party Dropdown */}
                                {
                                    userRole?.toLowerCase() !== 'web user' && (
                                        <div className='ps-2 pe-2 mar'
                                            style={{
                                                // width: '400px',
                                                minWidth: window.innerWidth <= 768 ? '65%' : '400px',
                                            }}>
                                            <Dropdown
                                                value={Party}
                                                onChange={(e) => OnPartyFilter(e)}
                                                options={options ?? []}
                                                optionLabel="Name"
                                                placeholder="Select Party"
                                                showClear
                                                filter
                                                valueTemplate={selectedOptionTemplate}
                                                itemTemplate={OptionTemplate}
                                            // className="w-100"
                                            />
                                        </div>
                                    )
                                }

                                {/* Right-aligned Controls */}
                                <div className="ms-auto d-flex align-items-center flex-wrap justify-content-end gap-2 pe-3">
                                    {/* 🧩 View Icons */}
                                    <div className="d-flex align-items-center">
                                        {/* { JSON.parse(localStorage.getItem('isRefresh')) && <button onClick={() => props.refreshData ? props.refreshData() : ""} className='btn btn-sm btn-outline-primary'>Refresh</button> }  */}
                                        {pageName === 'PACKETSEARCH' ? (
                                            <input
                                                type="text"
                                                placeholder="Password..."
                                                className="form-control form-control-sm me-3"
                                                style={{ width: '100px' }}
                                                onChange={(e) => handlePassChange(e.target.value)}
                                            />
                                        ) : null}

                                        <FaRectangleList
                                            size={30}
                                            className="me-2"
                                            color={ViewType === 'GridView' ? 'var(--IconColor)' : 'gray'}
                                            onClick={() => displayType('GridView')}
                                        />
                                        <IoGrid
                                            size={28}
                                            className="me-2"
                                            color={ViewType === 'CardView' ? 'var(--IconColor)' : 'gray'}
                                            onClick={() => displayType('CardView')}
                                        />
                                        {/* <HiChartSquareBar size={33} className='' color={ViewType == 'ChartView' ? 'var(---IconColor)' : 'Gray'} onClick={() => displayType('ChartView')} /> */}
                                        <FaObjectUngroup
                                            size={30}
                                            color={ViewType === 'BestPairCardView' ? 'var(--IconColor)' : 'gray'}
                                            onClick={() => displayType('BestPairCardView')}
                                        />
                                    </div>

                                    {/* 🌐 Summary Switch */}
                                    <Form className="text-end d-none d-lg-block">
                                        <Form.Check
                                            type="switch"
                                            id="custom-switch"
                                            name="SummarySwitch"
                                            label="Summary"
                                            checked={showTotal}
                                            onChange={handleSwitchChange}
                                        />
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >


            <div className='Datacontainer'>
                <div ref={dataDivRef} className='dataDiv px-2' style={{ overflowY: 'auto' }}>

                    {gridContent}

                    {
                        ViewType == 'CardView' && <InfiniteScroll
                            dataLength={visibleItems.length}
                            next={fetchMoreData}
                            hasMore={true}
                            height={cardViewHeight}
                            loader={<h4></h4>}
                        >
                            <div className="row m-0">
                                {videoContent}
                            </div>
                        </InfiniteScroll>
                    }

                    {
                        ViewType == 'BestPairCardView' && <InfiniteScroll
                            dataLength={visibleItems.length}
                            next={fetchMoreData}
                            hasMore={true}
                            height={cardViewHeight}
                            loader={<h4></h4>}
                        >
                            <div className="row m-0">
                                {bestPairContent}
                            </div>
                        </InfiniteScroll>
                    }

                    {
                        ViewType == "ChartView" && <div style={{ height: cardViewHeight }}> {chartContent} </div>
                    }


                </div>
            </div >

            <PacketSearchComp openPacketSearchCom={openPacketSearchCom} SearchType={props.SearchType} setopenPacketSearchCom={setopenPacketSearchCom} />

            <PktErrorComp
                show={showModal}
                onHide={() => setShowModal(false)}
                dataSource={PktErrData}
                onExcludePackets={handleExcludePackets}
            />

            {/* {
        splitValue?.length > 1 &&
            <Modal show={isModalOpen} onHide={handleCloseModal} className="left-side-modal" >
                <Modal.Header>
                    <h5>Select Mobile Number</h5>
                </Modal.Header>
                <Modal.Body>
                    {
                        splitValue && splitValue?.map((x, i) => (
                            <>
                                <p key={i} style={{ cursor: 'pointer' }}>
                                    <RiWhatsappFill className='me-2' size={25} color='green' />
                                    <span onClick={() => handleOpenWhatsApp(splitNumberValue[i])} className='fw-medium'>
                                        {x}
                                    </span>
                                </p>
                            </>
                        ))
                    }
                </Modal.Body>
                <Modal.Footer>
                    <button variant="secondary" className='btnbluedark' onClick={handleCloseModal}> Close </button>
                </Modal.Footer>
            </Modal>
    } */}

            <Modal
                show={isOfferCountModal}
                onHide={() => setIsOfferCountModal(false)}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                style={{ Width: '2000px', margin: 'auto' }}
                dialogClassName="custom-modal modalwidth"
            >
                <Modal.Body>
                    {
                        ColumConfig && ColumConfig?.length > 0 && <GlidGrid
                            data={offerCountRowData}
                            columns={ColumConfig}
                            height={`${gridHeight}px`}
                            GetselectedRow={GetselectedRow}
                            ExcelGet={"OFFERISS"}
                            ViewparaName={"OFFERISS"}
                        />
                    }
                </Modal.Body>
                <Modal.Footer>
                    <button
                        variant="secondary"
                        className="savepanelBtn btn-primary"
                    >
                        Send
                    </button>
                    <button
                        variant="secondary"
                        className="savepanelBtn btn-primary"
                        onClick={() => setIsOfferCountModal(false)}
                    >
                        Close
                    </button>
                </Modal.Footer>
            </Modal>


            <Modal show={isModalVideoLink} onHide={handleCloseModalVideoLink} className='left-side-modal'>
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    {
                        Array.isArray(VideoLinkRow) && VideoLinkRow.length > 0 ? (
                            VideoLinkRow?.map((x, i) => (
                                <React.Fragment key={i}>
                                    <div className='row'>
                                        <div className='col-12 text-center'>
                                            <img src={x?.PHOTOLINK} alt={`Image ${i}`} style={{ width: '100%', maxWidth: "466px" }}
                                            />
                                        </div>
                                    </div>
                                    <div className='row mt-3'>
                                        {/* Copy Image Link */}
                                        <div className='col-6'>
                                            <button className='btnOutlineBlue w-100' onClick={() => navigator.clipboard.writeText(x?.PHOTOLINK)}>
                                                <FaLink size={17} className='me-2' />
                                                Copy Image Link
                                            </button>
                                        </div>
                                        {/* Download Image */}
                                        <div className='col-6'>
                                            <button
                                                className='btnOutlineBlue w-100'
                                                onClick={async () => {
                                                    try {
                                                        const response = await fetch(x?.PHOTOLINK);
                                                        if (!response.ok) throw new Error('Failed to fetch image');
                                                        const blob = await response.blob();
                                                        const url = window.URL.createObjectURL(blob);

                                                        // Create a temporary <a> element for downloading the image
                                                        const a = document.createElement('a');
                                                        a.style.display = 'none';
                                                        a.href = url;
                                                        a.download = `${x?.PKTID}.jpg`; // Adjust file name and extension as needed
                                                        document.body.appendChild(a);
                                                        a.click();

                                                        // Clean up
                                                        window.URL.revokeObjectURL(url);
                                                        document.body.removeChild(a);
                                                    } catch (error) {
                                                        console.error('Error downloading image:', error);
                                                        alert('Failed to download the image. Please try again.');
                                                    }
                                                }}
                                            >
                                                <IoMdDownload size={17} className='me-2' />
                                                Download Image
                                            </button>
                                        </div>

                                    </div>
                                    <div className='row mt-1'>
                                        {/* Copy Video Link */}
                                        <div className='col-6'>
                                            <button className='btnOutlineBlue w-100' onClick={() => navigator.clipboard.writeText(x?.VIDEOLINK1)}>
                                                <FaLink size={17} className='me-2' />
                                                Copy Video Link
                                            </button>
                                        </div>
                                        {/* Download Video */}
                                        <div className='col-6'>
                                            <button
                                                className='btnOutlineBlue w-100'
                                                onClick={async () => {
                                                    try {
                                                        const response = await fetch(x?.VIDEOLINK1);
                                                        if (!response.ok) throw new Error('Failed to fetch video');
                                                        const blob = await response.blob();
                                                        const url = window.URL.createObjectURL(blob);

                                                        // Create a temporary <a> element for downloading the video
                                                        const a = document.createElement('a');
                                                        a.style.display = 'none';
                                                        a.href = url;
                                                        a.download = `${x?.PKTID}.mp4`; // Adjust file name and extension as needed
                                                        document.body.appendChild(a);
                                                        a.click();

                                                        // Clean up
                                                        window.URL.revokeObjectURL(url);
                                                        document.body.removeChild(a);
                                                    } catch (error) {
                                                        console.error('Error downloading video:', error);
                                                        alert('Failed to download the video. Please try again.');
                                                    }
                                                }}
                                            >
                                                <IoMdDownload size={17} className='me-2' />
                                                Download Video
                                            </button>
                                        </div>
                                    </div>
                                </React.Fragment>
                            ))
                        ) : (
                            <p>No videos available</p>
                        )
                    }
                </Modal.Body>
                {/* <Modal.Footer>
                    <button variant="secondary" className='btnbluedark' onClick={handleCloseModalVideoLink}> Close </button>
                </Modal.Footer> */}
            </Modal>

            <Modal show={showLocSearchModal} onHide={() => setShowLocSearchModal(false)} // className="search-modal"
                className="left-side-modal"
                size="sm"
            >
                {/* <Modal.Header closeButton>
                            <h5 className="modal-title">Purchase Search</h5>
                        </Modal.Header> */}
                <Modal.Body>
                    {OptLoc?.length > 0 && LocationColConfig?.length > 0 && (
                        <GlidGrid
                            data={OptLoc}
                            columns={LocationColConfig}
                            height="20vh"
                            onCellDoubleClicked={handleLocDoubleClick}
                            enableVirtualization
                            quickFilter
                        />
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <div className='gridBottomtHeight'>
                        <button className='btn btn-sm btn-outline-primary F12 ml-md-2' variant="secondary"
                            onClick={() => {
                                setShowLocSearchModal(false);
                            }}>
                            <RiCloseCircleFill size={17} className='me-1' />
                            Close
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal
                show={ShowAccSearchModal}
                onHide={() => setShowAccSearchModal(false)}
                className="left-side-modal"
            >
                <Modal.Body>
                    <div className="grid-component">
                        <GlidGrid
                            data={OptAcc}
                            columns={AccColConfig}
                            height="500px"
                            ExcelGet="PKTSEARCHACCMAST"
                            ViewparaName="PKTSEARCHACCMAST"
                            GetselectedRow={GetselectedRowAcc}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button variant="secondary" className="savepanelBtn btn-primary" onClick={handleDone}>
                        Send
                    </button>
                    <button variant="secondary" className="savepanelBtn btn-primary" onClick={() => setShowAccSearchModal(false)}>
                        Close
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    )

}

export default memo(DataListComp)